"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTooltip = void 0;
const react_1 = __importStar(require("react"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function useTooltip(type, children, childrenProps) {
    const [opened, setOpened] = (0, react_1.useState)(false);
    const openTooltip = (0, event_callback_hook_1.useEventCallback)(() => setOpened(true));
    const closeTooltip = (0, event_callback_hook_1.useEventCallback)(() => setOpened(false));
    const wrappedChildren = react_1.default.Children.toArray(children)
        .filter(react_1.default.isValidElement)
        .map((child) => react_1.default.cloneElement(child, childrenProps))[0];
    return {
        opened,
        openTooltip,
        closeTooltip,
        wrappedChildren,
    };
}
exports.useTooltip = useTooltip;
//# sourceMappingURL=tooltip-hook.js.map